import { CurrenciesView } from "@/admin/settings/CurrenciesView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/currencies")({
    component: CurrenciesView,
});
